import scrollMonitor from 'scrollmonitor';
import scrollToElement from 'scroll-to-element';
import toArray from './../../scripts/to-array';
import classnameToggle from './../../scripts/classname-toggle';

toArray(document.querySelectorAll('[data-component="careers-detail"]')).forEach((component) => {
  const buttonContainer = component.querySelector('[data-apply-cta-container]');
  const button = component.querySelector('[data-apply-cta]');
  const buttonContainerWatcher = scrollMonitor.create(buttonContainer);

  function visibilityChecker() {
    classnameToggle(button, 'is-sticky', !buttonContainerWatcher.isFullyInViewport && !buttonContainerWatcher.isBelowViewport);
  }

  buttonContainerWatcher.stateChange(visibilityChecker);
  visibilityChecker();

  // Smooth scroll
  const mobileNavLinks = component.querySelectorAll('[data-careers-detail-mobile-nav-link]');

  mobileNavLinks.forEach((link) => {
    const href = link.getAttribute('href');
    const options = {
      offset: -65,
      ease: 'out-circ',
      duration: 1000,
    };

    link.addEventListener('click', (e) => {
      e.preventDefault();
      scrollToElement(href, options);
    });
  });
});

